import React, { useState } from 'react';
import { List, Form, Button } from 'semantic-ui-react';
import './Comments.css';
import { reportError, AuthorWidget } from '..';
var CommentView = function (_a) {
    var c = _a.comment;
    var author = c.author, comment = c.comment, created = c.created;
    return (React.createElement(List.Item, null,
        React.createElement(List.Content, null,
            React.createElement(List.Description, null,
                React.createElement(AuthorWidget, { userId: author }),
                ' on ',
                new Date(created).toLocaleString()),
            React.createElement(List.Header, null, comment))));
};
export var CommentsList = function (_a) {
    var comments = _a.comments;
    return (React.createElement(List, { relaxed: true, divided: true, size: "big", className: "comments-list" }, comments.map(function (c) { return (React.createElement(CommentView, { key: c.id, comment: c })); })));
};
export var PostCommentWidget = function (_a) {
    var onComment = _a.onComment;
    var _b = useState(null), comment = _b[0], setComment = _b[1];
    return (React.createElement("div", { onClick: function (e) {
            // when put into map item click in form input causes the item to expand
            e.stopPropagation();
        } },
        React.createElement(Form, { onSubmit: function (e) {
                e.preventDefault();
                !!comment &&
                    onComment(comment)
                        .then(function () { return setComment(null); })
                        .catch(reportError);
            } },
            React.createElement(Form.Input, { value: comment || '', placeholder: "Your comment here", action: React.createElement(Button, { icon: "send" }), onChange: function (e) { return setComment(e.target.value); } }))));
};
//# sourceMappingURL=Comments.js.map